import toast from "react-hot-toast";

const CustomerOrderButton = ({ dismiss: toastId, transaction_id }) => {
  return (
    <>
      <span className="w-full flex flex-col">
        {/* Text */}
        <span className="text-center w-full h-full flex flex-col justify-center gap-y-2 py-2 px-5">
          <span>سفارش شما ثبت شد</span>
          <span>شماره سفارش: {transaction_id}#</span>
          <span>
            <button
              onClick={() => toast.dismiss(toastId)}
              className="bg-red-600 border-2 border-red-600 text-gray-200
          mx-5 rounded-xl px-4 py-0.5 transition-all ease-linear focus:ring-0
          duration-100 hover:transition-all hover:ease-linear hover:duration-100"
            >
              بستن
            </button>
          </span>
        </span>
      </span>
    </>
  );
};

export default CustomerOrderButton;
